import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FiArrowLeft, FiBookOpen } from 'react-icons/fi';
import Sidebar from '../../../Sidebar';
import IELTSCourse from './IELTSCourse';
import { allCourseData } from './data';
import '../../English.css';
import './DynamicLesson.css';

export default function DynamicLesson() {
  const { courseId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const lessonId = searchParams.get('lessonId') || courseId;
  const difficulty = parseInt(searchParams.get('difficulty'), 10) || 3;
  const data = allCourseData[courseId];

  if (!data) {
    return (
      <div className="english-layout">
        <Sidebar />
        <main className="english-main">
          <div className="dynamic-lesson-missing">
            <div className="dynamic-lesson-missing__icon" aria-hidden="true">
              <FiBookOpen />
            </div>
            <h1>Lesson not found</h1>
            <p>
              No course is registered for{' '}
              <span className="dynamic-lesson-missing__slug">
                {courseId || 'this lesson'}
              </span>
              . It may have been removed, or the link is outdated.
            </p>
            <button
              type="button"
              className="btn-lwz-primary"
              onClick={() => navigate('/exams/english/journey')}
            >
              <FiArrowLeft />
              Back to journey
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <IELTSCourse {...data} lessonId={lessonId} difficulty={difficulty} />
  );
}
